export const CLEAR_CACHE = 'CACHE:CLEAR';
export const ADD_CACHE_ENTRY = 'CACHE:ADD';
export const PURGE_EXPIRED_CACHE_ENTRIES = 'CACHE:PURGE';
